"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GOOGLE_MAP_SCRIPT_BASE_URL = void 0;
var GOOGLE_MAP_SCRIPT_BASE_URL = "https://maps.googleapis.com/maps/api/js";
exports.GOOGLE_MAP_SCRIPT_BASE_URL = GOOGLE_MAP_SCRIPT_BASE_URL;